/* eslint-disable */
// @ts-nocheck
import React, { useState, useEffect, useRef, useContext } from 'react';
import {
  Card,
  CardHeader,
  Checkbox,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Button,
  Grid,
  TextField,
  InputAdornment,
  Paper,
  Popper,
  ClickAwayListener,
  Fade,
  Chip,
  Box,
  FormLabel,
  FormControl,
} from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import axios from 'axios';
import { useIntl } from 'react-intl';
import { LOCALES } from 'app/i18n-locale/locales-constants';
import { LanguageContext } from 'context/intl.context';
import { useStyles } from 'app/components/shared/groups-menu-multi-select/utils';
import closeIcon from 'assets/close-icon-grey.svg';

function not(a: any[], b: any[]) {
  return a.filter(value => b.indexOf(value) === -1);
}

function intersection(a: any[], b: any[]) {
  return a.filter(value => b.indexOf(value) !== -1);
}

function union(a: any[], b: any[]) {
  return [...a, ...not(b, a)];
}

const RouteTransferList = ({ selectedIds, onChange, organisationId }: any) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [open, setOpen] = useState(false);
  const [checked, setChecked] = useState<any[]>([]);
  const [allRoutes, setAllRoutes] = useState<any[]>([]);
  const [availableRoutes, setAvailableRoutes] = useState<any[]>([]);
  const [selectedRoutes, setSelectedRoutes] = useState<any[]>([]);
  const [searchText, setSearchText] = useState('');
  const initializedRef = useRef(false);
  const classes = useStyles();
  const intl = useIntl();
  const { locale } = useContext(LanguageContext);
  const isRtl = locale === LOCALES.ARABIC;

  const currentLang = localStorage.getItem('EASY_MOBILITY_LANGUAGE') || 'en-us';
  const isAr = currentLang.toLowerCase() === 'ar-eg';

  const getAuthHeaders = () => {
    const authDataString = localStorage.getItem('authData');
    if (!authDataString) return {};
    const parsed = JSON.parse(authDataString);
    const token = parsed.userToken;
    return {
      'access-token': token?.['access-token'] || token?.access_token || '',
      uid: token?.uid || '',
      client: token?.client || '',
      Authorization: 'Bearer ' + (localStorage.getItem('dashboard_token') || ''),
    };
  };

  useEffect(() => {
    if (!organisationId) {
      setAllRoutes([]);
      return;
    }
    axios
      .get(
        `${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/web_portal/fare_media_policy_capping/discount_band_assignment/routes?organisation_id=${organisationId}`,
        { headers: getAuthHeaders() }
      )
      .then(res => {
        if (res.data?.success) setAllRoutes(res.data.data || []);
      })
      .catch(() => {});
  }, [organisationId]);

  useEffect(() => {
    if (allRoutes.length === 0) return;
    const parentIds = new Set((selectedIds || []).map((id: any) => String(id)));
    const initialSelected: any[] = [];
    const initialAvailable: any[] = [];
    allRoutes.forEach(route => {
      if (parentIds.has(String(route.id))) {
        initialSelected.push(route);
      } else {
        initialAvailable.push(route);
      }
    });
    setAvailableRoutes(initialAvailable);
    setSelectedRoutes(initialSelected);
    initializedRef.current = true;
  }, [allRoutes, JSON.stringify(selectedIds)]);

  useEffect(() => {
    if (!initializedRef.current) return;
    const ids = selectedRoutes.map(r => r.id);
    if (JSON.stringify(ids.sort()) !== JSON.stringify([...(selectedIds || [])].sort())) {
      onChange(ids);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedRoutes]);

  const getRouteName = (route: any) =>
    isAr ? route.ar_name || route.en_name : route.en_name || route.ar_name;

  const filteredAvailable = availableRoutes.filter(route =>
    getRouteName(route)?.toLowerCase().includes(searchText.toLowerCase())
  );

  const moveItems = (
    toMoveList: any[],
    sourceList: any[],
    targetList: any[],
    setSource: Function,
    setTarget: Function
  ) => {
    const toMoveItems = intersection(checked, toMoveList);
    setTarget(targetList.concat(toMoveItems));
    setSource(not(sourceList, toMoveItems));
    setChecked(not(checked, toMoveItems));
  };

  const handleToggle = (value: any) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];
    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    setChecked(newChecked);
  };

  const numberOfChecked = (items: any[]) => intersection(checked, items).length;

  const handleToggleAll = (items: any[]) => () => {
    if (numberOfChecked(items) === items.length) {
      setChecked(not(checked, items));
    } else {
      setChecked(union(checked, items));
    }
  };

  const handleCheckedRight = () =>
    moveItems(availableRoutes, availableRoutes, selectedRoutes, setAvailableRoutes, setSelectedRoutes);

  const handleCheckedLeft = () =>
    moveItems(selectedRoutes, selectedRoutes, availableRoutes, setSelectedRoutes, setAvailableRoutes);

  const handleRemoveChip = (route: any, event: any) => {
    event.stopPropagation();
    setSelectedRoutes(prev => not(prev, [route]));
    setAvailableRoutes(prev => [...prev, route]);
  };

  const handleOpenToggle = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    setOpen(prev => !prev);
  };

  const handleClickAway = () => setOpen(false);

  const routeListPanel = (title: string, items: any[], showSearch = false) => (
    <Card
      style={{
        borderRadius: 8,
        border: '1px solid #DFE4EA',
        boxSizing: 'border-box',
        width: 280,
        boxShadow: 'none',
        backgroundColor: '#fff',
      }}
    >
      <CardHeader
        style={{ padding: '8px 12px', backgroundColor: '#F4F6FB', borderBottom: '1px solid #DFE4EA' }}
        avatar={
          <Checkbox
            onClick={handleToggleAll(items)}
            checked={items.length > 0 && numberOfChecked(items) === items.length}
            indeterminate={numberOfChecked(items) > 0 && numberOfChecked(items) < items.length}
            disabled={items.length === 0}
            style={{ padding: 0, color: '#FF6B38' }}
          />
        }
        title={
          <span style={{ fontSize: 12, fontWeight: 700, color: '#444' }}>{title}</span>
        }
        subheader={
          <span style={{ fontSize: 11, color: '#9B9B9B' }}>
            {numberOfChecked(items)}/{items.length} {intl.formatMessage({ id: 'selected' })}
          </span>
        }
      />

      {showSearch && (
        <div style={{ padding: '6px 8px', margin: '1px', marginTop: '4px', borderBottom: '1px solid #DFE4EA', backgroundColor: '#fff' }}>
          <TextField
            size="small"
            placeholder={intl.messages['search'] ? intl.formatMessage({ id: 'search' }) : 'Search...'}
            value={searchText}
            onChange={e => setSearchText(e.target.value)}
            fullWidth
            variant="outlined"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon style={{ fontSize: 16, color: '#9B9B9B' }} />
                </InputAdornment>
              ),
              style: { height: 32, fontSize: 12 },
            }}
          />
        </div>
      )}

      <Divider />

      <List style={{ width: 280, height: 180, overflowY: 'auto' }} dense component="div" role="list">
        {items.map((value: any) => {
          const labelId = `transfer-list-item-${value.id}-label`;
          return (
            <ListItem
              key={value.id}
              role="listitem"
              button
              onClick={handleToggle(value)}
              style={{
                paddingTop: 4,
                paddingBottom: 4,
                flexDirection: isRtl ? 'row-reverse' : 'row',
              }}
            >
              <ListItemIcon style={{ minWidth: 0, marginInlineEnd: 8 }}>
                <Checkbox
                  checked={checked.indexOf(value) !== -1}
                  tabIndex={-1}
                  disableRipple
                  style={{ padding: 0, color: '#FF6B38' }}
                />
              </ListItemIcon>
              <ListItemText
                id={labelId}
                primary={getRouteName(value)}
                primaryTypographyProps={{ variant: 'body2' }}
                style={{ textAlign: isRtl ? 'right' : 'left' }}
              />
            </ListItem>
          );
        })}
        <ListItem />
      </List>
    </Card>
  );

  const popperId = open ? 'route-transfer-popper' : undefined;

  return (
    <FormControl fullWidth>
      <FormLabel className={classes.formLabel}>
        {intl.messages['Routes'] ? intl.formatMessage({ id: 'Routes' }) : 'Routes'}
      </FormLabel>

      {/* Trigger — mirrors MultiSelect style, shows chips for selected routes */}
      <div
        aria-describedby={popperId}
        onClick={handleOpenToggle}
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'center',
          minHeight: 40,
          padding: '4px 8px',
          paddingRight: 32,
          border: `1px solid ${open ? '#3f51b5' : 'rgba(0,0,0,0.23)'}`,
          borderRadius: 4,
          backgroundColor: '#fff',
          cursor: 'pointer',
          boxSizing: 'border-box',
          position: 'relative',
        }}
      >
        {selectedRoutes.length > 0 ? (
          <Box style={{ display: 'flex', flexWrap: 'wrap' }}>
            {selectedRoutes.map(route => (
              <Chip
                key={route.id}
                label={getRouteName(route)}
                style={{ margin: 4 }}
                onDelete={e => handleRemoveChip(route, e)}
                onMouseDown={e => e.stopPropagation()}
                deleteIcon={<img src={closeIcon} alt="close" />}
                classes={{
                  deleteIcon: classes.deleteIcon,
                  root: classes.chipRoot,
                  label: classes.chipLabel,
                }}
              />
            ))}
          </Box>
        ) : (
          <span className={classes.placeholder}>
            {intl.formatMessage({ id: 'all' })}
          </span>
        )}

        {/* Dropdown arrow */}
        <ExpandMoreIcon
          style={{
            position: 'absolute',
            right: 8,
            top: '50%',
            transform: open ? 'translateY(-50%) rotate(180deg)' : 'translateY(-50%) rotate(0deg)',
            transition: 'transform 0.2s ease',
            color: 'rgba(0,0,0,0.54)',
            fontSize: 20,
            pointerEvents: 'none',
          }}
        />
      </div>

      {/* Popper — two-panel transfer list */}
      <Popper
        id={popperId}
        open={open}
        anchorEl={anchorEl}
        placement="bottom-start"
        transition
        style={{ zIndex: 1300, marginTop: 6 }}
      >
        {({ TransitionProps }) => (
          <ClickAwayListener onClickAway={handleClickAway} mouseEvent="onMouseDown">
            <Fade {...TransitionProps} timeout={200}>
              <Paper
                variant="outlined"
                style={{
                  padding: 16,
                  borderRadius: 12,
                  backgroundColor: '#F4F6FB',
                  boxShadow: '0px 4px 16px rgba(0,0,0,0.15)',
                }}
              >
                <Grid container spacing={1} alignItems="center" wrap="nowrap">
                  <Grid item>
                    {routeListPanel(
                      intl.messages['AvailableRoutes']
                        ? intl.formatMessage({ id: 'AvailableRoutes' })
                        : 'Available Routes',
                      filteredAvailable,
                      true
                    )}
                  </Grid>

                  <Grid item style={{ padding: '0 8px' }}>
                    <Grid container direction="column" alignItems="center" spacing={1}>
                      <Grid item>
                        <Button
                          variant="outlined"
                          size="small"
                          onClick={handleCheckedRight}
                          disabled={intersection(checked, availableRoutes).length === 0}
                          style={{ minWidth: 36, color: '#FF6B38', borderColor: '#FF6B38' }}
                        >
                          {'>'}
                        </Button>
                      </Grid>
                      <Grid item>
                        <Button
                          variant="outlined"
                          size="small"
                          onClick={handleCheckedLeft}
                          disabled={intersection(checked, selectedRoutes).length === 0}
                          style={{ minWidth: 36, color: '#FF6B38', borderColor: '#FF6B38' }}
                        >
                          {'<'}
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item>
                    {routeListPanel(
                      intl.messages['SelectedRoutes']
                        ? intl.formatMessage({ id: 'SelectedRoutes' })
                        : 'Selected Routes',
                      selectedRoutes
                    )}
                  </Grid>
                </Grid>
              </Paper>
            </Fade>
          </ClickAwayListener>
        )}
      </Popper>
    </FormControl>
  );
};

export default RouteTransferList;
